<div class="container">
  <div class="header">
    <mat-icon class="header__logo" svgIcon="logo-wizbii-money"></mat-icon>
  </div>

  <div class="content">
    <div class="code">404</div>
    <div>
      <h1 class="title" i18n>Oups</h1>
      <p class="description" i18n>
        La page que vous recherchez n’existe pas, ou n’est pas disponible pour le moment. Nous investigons !
      </p>
      <button class="btn" [routerLink]="['/']" i18n>Revenir à l'accueil</button>
    </div>
  </div>
</div>
